import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { MainHeader } from "./components/MainHeader";
import { useMainHeaderStore } from "./components/MainHeader/helpers/useMainHeaderStore";
import { LendingsPageProvider } from "./pages/LendingsPage/helpers/useLendingsPageStore";

const HomePage = lazy(() => import("./pages/HomePage/ui/HomePage"));
const RafflePage = lazy(() => import("./pages/RaffflePage/ui/RaffflePage"));
const NFTPage = lazy(() => import("./pages/NFTPage/ui/NFTPage"));
const ProfilePage = lazy(() => import("./pages/Profile/ui/Profile"));
const CollectionPage = lazy(
  () => import("./pages/CollectionPage/ui/CollectionPage")
);
const BoughtNFT = lazy(() => import("./pages/BoughtNft/ui/BoughtNft"));
const CollectionsListPage = lazy(
  () => import("./pages/CollectionsListPage/ui/CollectionsListPage")
);
const PrivacyPage = lazy(() => import("./pages/PrivacyPage/ui/PrivacyPage"));
const TelegramGiftsListPage = lazy(
  () => import("./pages/TelegramGiftsCollectionsList/ui/TelegramGiftsList")
);
const CartCongratulations = lazy(
  () => import("./pages/CartCongratulationsPage/ui/CartCongratulations")
);
const LendingsPage = lazy(() => import("./pages/LendingsPage/ui/LendingsPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage/ui/NotFoundPage"));

/* eslint-disable mobx/missing-observer */
export function AppRouter() {
  const mainHeaderStore = useMainHeaderStore();

  return (
    <>
      <Suspense
        fallback={
          <div style={{ width: "100%", height: "100vh" }}>
            <MainHeader
              isScrolled={false}
              mainHeaderStore={mainHeaderStore}
              mainPage={false}
            />
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/raffle/:address" element={<RafflePage />} />
          <Route path="/nft/:address" element={<NFTPage />} />
          <Route path="/user/:address/:tab?" element={<ProfilePage />} />
          <Route
            path="/collection/:address/:tab?/:attributeHash?"
            element={<CollectionPage />}
          />
          <Route path="/bought-nft/:address" element={<BoughtNFT />} />
          <Route path="/rankings" element={<CollectionsListPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route
            path="/collections/telegram-gifts"
            element={<TelegramGiftsListPage />}
          />
          <Route path="/cart/congrats" element={<CartCongratulations />} />
          <Route
            path="/lendings"
            element={
              <LendingsPageProvider>
                <LendingsPage />
              </LendingsPageProvider>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </>
    //  <BrowserRouter>

    //  </BrowserRouter>
  );
}
